import { forwardRef, type ReactNode, type Ref } from 'react';
import type { BaseProps } from '../../theme/index.js';
import { useBaseAttrs, splitBaseProps } from '../_internal/factory.js';
import './Kbd.css';

export interface KbdProps extends BaseProps {
  children?: ReactNode;
}

/** Keyboard-shortcut visual key (`<kbd>` element). */
export const Kbd = forwardRef(function Kbd(
  { children, ...rest }: KbdProps,
  ref: Ref<HTMLElement>
): ReactNode {
  const base = useBaseAttrs('rr-kbd', rest);
  const { dom } = splitBaseProps(rest);
  return (
    <kbd {...dom} ref={ref} {...base.attrs} className={base.className} style={base.style}>
      {children}
    </kbd>
  );
});
